import { render } from "./PurchaseDefectiveItemCauseList.vue?vue&type=template&id=ddace836"
import script from "./PurchaseDefectiveItemCauseList.vue?vue&type=script&lang=js"
export * from "./PurchaseDefectiveItemCauseList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__